import {
  FaFacebook,
  FaGithub,
  FaInstagram,
  FaLinkedin,
  FaTwitter,
} from "react-icons/fa";
import RoundImage from "./shared/RoundImage";

export default function ProfileCard({
  details = {
    imgUrl: "",
    name: "Lalithaditya",
    designation: "Joint Secretary",
    github: "link",
    linkedin: "link",
    twitter: "link",
    instagram: "link",
    facebook: "link",
  },
}) {
  return (
    <div style={{ width: "max-content" }} className="card is-shadowless">
      <div className="card-content has-text-centered">
        <div className="level">
          <div
            className="level-item"
            style={{
              width: "240px",
              height: "300px",
              overflow: "hidden",
              borderRadius: "6%",
            }}
          >
            <RoundImage imageUrl={details.imgUrl} />
          </div>
        </div>
        <div className="content">
          <h1 className="title is-4">{details.name}</h1>
          <h2 className="subtitle is-6">{details.designation}</h2>
          <div
            className="is-flex is-justify-content-center"
            style={{ gap: "1rem" }}
          >
            {details.github ? (
              <a href={details.github}>
                <FaGithub />
              </a>
            ) : (
              <></>
            )}
            {details.linkedin ? (
              <a href={details.linkedin}>
                <FaLinkedin />
              </a>
            ) : (
              <></>
            )}
            {details.twitter ? (
              <a href={details.twitter}>
                <FaTwitter />
              </a>
            ) : (
              <></>
            )}
            {details.instagram ? (
              <a href={details.instagram}>
                <FaInstagram />
              </a>
            ) : (
              <></>
            )}
            {details.facebook ? (
              <a href={details.facebook}>
                <FaFacebook />
              </a>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
